import React, { useState } from "react";
import "./BitacoraAlmacen.css";

// Material UI Icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LocalBarIcon from '@mui/icons-material/LocalBar';

// Subcomponents
import InventarioGranelSection from "./BitacoraAlmacen/InventarioGranelSection";

const BitacoraAlmacen = () => {
  // Batch selector
  const [activeBatch, setActiveBatch] = useState("Lote 01-ENV-2026");
  const [showBatchDropdown, setShowBatchDropdown] = useState(false);
  const batches = ["Lote 01-ENV-2026", "Lote 02-ENV-2026", "Lote 03-ENV-2026"];

  // Tab navigation state (only Section II)
  const [activeTab, setActiveTab] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const tabsInfo = [
    { id: 0, title: "Sección II", name: "Granel", desc: "Inventarios de Mezcal a Granel", icon: LocalBarIcon, shortLabel: "II. Granel", theme: "status-cierre" }
  ];

  // ================= DATA HISTORY STATES =================
  const [granelRecords, setGranelRecords] = useState([
    {
      id: "GRA-ENV-01",
      fechaMovimiento: "2026-07-15",
      idContenedor: "C-10",
      noLote: "PROD-LOTE-01",
      categoria: "Mezcal Artesanal",
      clase: "Joven / Blanco",
      ingrediente: "Maguey Espadín",
      edad: "Sin edad",
      tipoMaguey: "Espadín",
      noAnalisis: "ANA-2026-098",
      invInicialVol: "1000",
      invInicialAlc: "48.5",
      entradaProcedencia: "Destilación Lote 01",
      entradaVolumen: "0",
      entradaAlc: "0.0",
      entradaVolAgua: "0",
      salidaVolumen: "300",
      salidaAlc: "48.5",
      salidaDestino: "Línea 1 - Envasado Botella 750ml",
      invFinalVol: "700",
      invFinalAlc: "48.5",
      observaciones: "Salida para primer turno de envasado.",
      inspector: "Ing. Carlos Mendoza (15/07/2026)",
      status: "aprobado"
    }
  ]);

  // ================= FORM STATES (SECCIÓN II) =================
  const [fechaMovimiento, setFechaMovimiento] = useState("2026-07-19");
  const [idContenedor, setIdContenedor] = useState("");
  const [noLote, setNoLote] = useState("");
  const [categoria, setCategoria] = useState("Mezcal Artesanal");
  const [clase, setClase] = useState("Joven / Blanco");
  const [ingrediente, setIngrediente] = useState("");
  const [edad, setEdad] = useState("Sin edad");
  const [tipoMaguey, setTipoMaguey] = useState("");
  const [noAnalisis, setNoAnalisis] = useState("");
  const [invInicialVol, setInvInicialVol] = useState("");
  const [invInicialAlc, setInvInicialAlc] = useState("");
  const [entradaProcedencia, setEntradaProcedencia] = useState("");
  const [entradaVolumen, setEntradaVolumen] = useState("");
  const [entradaAlc, setEntradaAlc] = useState("");
  const [entradaVolAgua, setEntradaVolAgua] = useState("");
  const [salidaVolumen, setSalidaVolumen] = useState("");
  const [salidaAlc, setSalidaAlc] = useState("");
  const [salidaDestino, setSalidaDestino] = useState("");
  const [invFinalVol, setInvFinalVol] = useState("");
  const [invFinalAlc, setInvFinalAlc] = useState("");
  const [observaciones, setObservaciones] = useState("");

  // ================= SAVE HANDLER (SECCIÓN II) =================
  const handleSaveGranel = (status) => {
    const newRecord = {
      id: `GRA-ENV-0${granelRecords.length + 1}`,
      fechaMovimiento,
      idContenedor,
      noLote,
      categoria,
      clase,
      ingrediente,
      edad,
      tipoMaguey,
      noAnalisis,
      invInicialVol,
      invInicialAlc,
      entradaProcedencia,
      entradaVolumen,
      entradaAlc,
      entradaVolAgua,
      salidaVolumen,
      salidaAlc,
      salidaDestino,
      invFinalVol,
      invFinalAlc,
      observaciones: observaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setGranelRecords([...granelRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Movimiento de Granel registrado exitosamente en Bitácora de Almacén!" : "Borrador guardado.");
  };

  return (
    <div className="container2">
      {/* Decorative Blurs */}
      <div className="glow-blob glow-1"></div>
      <div className="glow-blob glow-2"></div>

      {/* HEADER */}
      <header className="main-trace-header">
        <div className="header-branding">
          <div className="header-icon-box" style={{ background: "linear-gradient(135deg, #10B981 0%, #059669 100%)", boxShadow: "0 8px 18px rgba(16, 185, 129, 0.25)" }}>
            <LocalBarIcon style={{ fontSize: 30 }} />
          </div>
          <div>
            <div className="header-tag">COMERCAM • TRAZABILIDAD COMERCIAL</div>
            <h1>Bitácora de Almacén de Mezcal</h1>
            <p>Control integral de inventarios a granel y movimientos de almacenamiento</p>
          </div>
        </div>

        <div className="header-controls-envasado">
          <span className={`status-badge-envasado ${tabsInfo[activeTab]?.theme || 'status-cierre'}`}>
            {tabsInfo[activeTab]?.title} • {tabsInfo[activeTab]?.name}
          </span>

          <div style={{ position: "relative" }}>
            <button 
              type="button"
              onClick={() => setShowBatchDropdown(!showBatchDropdown)}
              className="batch-select-btn"
            >
              <span className="batch-label">Lote:</span>
              <span className="batch-val">{activeBatch}</span>
              <KeyboardArrowDownIcon style={{ fontSize: 18 }} />
            </button>

            {showBatchDropdown && (
              <div className="dropdown-menu-custom">
                {batches.map((batch, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => {
                      setActiveBatch(batch);
                      setShowBatchDropdown(false);
                    }}
                    className={`dropdown-item-custom ${activeBatch === batch ? 'active' : ''}`}
                  >
                    {batch}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </header>

      {/* SECTIONS TABS (SEGMENTED PILLS) */}
      <div className="tabs-nav-bar-container">
        <div className="segmented-pill-container">
          {tabsInfo.map((tab) => {
            const IconComponent = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                className={`segmented-pill-btn ${isActive ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(tab.id);
                  setIsFormOpen(false);
                }}
              >
                <IconComponent style={{ fontSize: 16 }} />
                <span>{tab.shortLabel}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* MAIN CONTENTS CONTAINER */}
      <main className="section-tab-container animate-fadeIn">
          {/* SECCIÓN II: GRANEL */}
          {activeTab === 0 && (
            <InventarioGranelSection
              granelRecords={granelRecords}
              isFormOpen={isFormOpen}
              setIsFormOpen={setIsFormOpen}
              fechaMovimiento={fechaMovimiento}
              setFechaMovimiento={setFechaMovimiento}
              idContenedor={idContenedor}
              setIdContenedor={setIdContenedor}
              noLote={noLote}
              setNoLote={setNoLote}
              categoria={categoria}
              setCategoria={setCategoria}
              clase={clase}
              setClase={setClase}
              ingrediente={ingrediente}
              setIngrediente={setIngrediente}
              edad={edad}
              setEdad={setEdad}
              tipoMaguey={tipoMaguey}
              setTipoMaguey={setTipoMaguey}
              noAnalisis={noAnalisis}
              setNoAnalisis={setNoAnalisis}
              invInicialVol={invInicialVol}
              setInvInicialVol={setInvInicialVol}
              invInicialAlc={invInicialAlc}
              setInvInicialAlc={setInvInicialAlc}
              entradaProcedencia={entradaProcedencia}
              setEntradaProcedencia={setEntradaProcedencia}
              entradaVolumen={entradaVolumen}
              setEntradaVolumen={setEntradaVolumen}
              entradaAlc={entradaAlc}
              setEntradaAlc={setEntradaAlc}
              entradaVolAgua={entradaVolAgua}
              setEntradaVolAgua={setEntradaVolAgua}
              salidaVolumen={salidaVolumen}
              setSalidaVolumen={setSalidaVolumen}
              salidaAlc={salidaAlc}
              setSalidaAlc={setSalidaAlc}
              salidaDestino={salidaDestino}
              setSalidaDestino={setSalidaDestino}
              invFinalVol={invFinalVol}
              setInvFinalVol={setInvFinalVol}
              invFinalAlc={invFinalAlc}
              setInvFinalAlc={setInvFinalAlc}
              observaciones={observaciones}
              setObservaciones={setObservaciones}
              handleSaveGranel={handleSaveGranel}
            />
          )}
        </main>
    </div>
  );
};

export default BitacoraAlmacen;